// Queries
import deliveryRequest from "./DeliveryRequestQuery.gql";

// Mutations
import addChangeRequestForDelivery from "./AddChangeRequestForDeliveryMutation.gql";
import updateDeliveryRequest from "./UpdateDeliveryRequestMutation.gql";

export const Query = {
    deliveryRequest,
};

export const Mutation = {
    updateDeliveryRequest,
    addChangeRequestForDelivery,
};
